import { useMemo } from 'react';

export enum UnitListURLParam {
    showActiveOnly = 'showActiveOnly',
}

export default function useURLParam(name: UnitListURLParam) {
    return useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        const param = params.get(name);

        if (!param) return '';

        return param;
    }, [name]);
}
